import { Button, DatePicker, Form, Typography } from 'antd';
import { LoupIcon } from 'assets';
import { Select } from 'components/common';
import React, { useEffect, useRef } from 'react';
import OmniChannelCustomerSelect from './OmniChannelCustomerSelect';
import { useOmniHistoriesManageContext } from 'contexts';
import { messages, omniChatMessages } from 'messages';
import OmniChannelSourceSelect from './OmniChannelSourceSelect';
import dayjs from 'dayjs';

type Props = {
  onCancel?: () => void;
};

const OmniChannelChatHistoriesFilterForm: React.FC<Props> = ({ onCancel }) => {
  const { searchChatSessions, loadingSearchChatSession, setChatSession, originalArgs } =
    useOmniHistoriesManageContext();

  const firstRef = useRef(true);
  const [form] = Form.useForm();

  useEffect(() => {
    if (firstRef.current && originalArgs?.fromStartTime) {
      console.log(originalArgs);
      form.setFieldsValue({
        time: [
          originalArgs?.fromStartTime ? dayjs(originalArgs.fromStartTime) : undefined,
          originalArgs?.toStartTime ? dayjs(originalArgs.toStartTime) : undefined
        ],
        source: originalArgs?.source
      });
      firstRef.current = false;
    }
  }, [originalArgs]);

  return (
    <Form
      form={form}
      className='flex-1 px-5 py-8'
      layout='vertical'
      onFinish={(values) => {
        setChatSession(undefined);
        const [id, pageId] = values?.customerId?.split(':') || [];
        searchChatSessions({
          fromStartTime: values.time?.[0]?.startOf('day').toISOString(),
          toStartTime: values.time?.[1]?.endOf('day').toISOString(),
          customerId: id,
          pageId,
          source: values.source
        });
      }}
    >
      <Form.Item
        className='mb-6'
        name='customerId'
        label={<Typography.Text className='text-sm font-semibold'>Tên khách hàng</Typography.Text>}
      >
        <OmniChannelCustomerSelect allowClear placeholder={omniChatMessages.selectCustomerPlaceholder} />
      </Form.Item>

      <Form.Item
        className='mb-6'
        name='time'
        label={<Typography.Text className='text-sm font-semibold'>Thời gian</Typography.Text>}
      >
        <DatePicker.RangePicker
          format={'DD/MM/YYYY'}
          className='w-full'
          placeholder={['Ngày bắt đầu', 'Ngày kết thúc']}
        />
      </Form.Item>

      <Form.Item
        className='mb-8'
        name='source'
        label={<Typography.Text className='text-sm font-semibold'>Kênh chat</Typography.Text>}
      >
        <OmniChannelSourceSelect isAll placeholder={omniChatMessages.selectSourcePlaceholder} />
      </Form.Item>
      <Form.Item noStyle name='pageId' />

      <Button
        loading={loadingSearchChatSession}
        type='primary'
        size='large'
        icon={<LoupIcon />}
        className='h-12 w-full'
        htmlType='submit'
      >
        {messages.search}
      </Button>
    </Form>
  );
};
export default OmniChannelChatHistoriesFilterForm;
